document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Kaching3.js loaded");

  const VAT_MULTIPLIER = 1.25;
  const PRICE_SELECTORS = [
    ".kaching-bundles__bar-price",
    ".kaching-bundles__bar-full-price"
  ];

  function parsePrice(text) {
    // Fjern alt undtagen tal, punktum og komma
    let cleaned = text.replace(/[^\d.,]/g, "");

    // Hvis både . og , findes → antag . = tusind, , = decimal
    if (cleaned.includes(".") && cleaned.includes(",")) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else if (cleaned.includes(",") && !cleaned.includes(".")) {
      // Kun komma → decimal
      cleaned = cleaned.replace(",", ".");
    }
    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function formatDKK(value) {
    // 2 decimaler, komma som decimal, punktum som tusind
    return value
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function getPriceElements(root = document) {
    const list = [];
    PRICE_SELECTORS.forEach(sel => {
      root.querySelectorAll(sel).forEach(el => list.push(el));
    });

    // Tjek shadow roots i kaching-bundle (hvis appen bruger dem)
    root.querySelectorAll("kaching-bundle").forEach(bundle => {
      if (bundle.shadowRoot) {
        PRICE_SELECTORS.forEach(sel => {
          bundle.shadowRoot.querySelectorAll(sel).forEach(el => list.push(el));
        });
      }
    });

    return list;
  }

  function markBundlesReady() {
    document.querySelectorAll(".kaching-bundles").forEach(el => {
      el.setAttribute("data-ready", "true");
    });
  }

  function updateKachingPrices(root = document) {
    let count = 0;

    getPriceElements(root).forEach((element) => {
      const originalText = element.innerText.trim();
      if (element.hasAttribute("data-vat-updated")) return;

      const priceValue = parsePrice(originalText);
      if (priceValue && priceValue > 0) {
        const newPrice = priceValue * VAT_MULTIPLIER;
        element.innerText = `${formatDKK(newPrice)} kr`;
        element.setAttribute("data-vat-updated", "true");
        count++;
      }
    });

    if (count > 0) {
      console.log(`✅ VAT updated on ${count} price element(s).`);
      markBundlesReady();
    }
    return count;
  }

  // 1) Kør straks
  updateKachingPrices();

  // 2) Poll kortvarigt efter load (fanger lazy render)
  let attempts = 0;
  const maxAttempts = 40; // ~10s ved 250ms
  const poll = setInterval(() => {
    attempts++;
    const updated = updateKachingPrices();
    if (updated > 0 || attempts >= maxAttempts) {
      clearInterval(poll);
    }
  }, 250);

  // 3) Global MutationObserver – fanger alle DOM-tilføjelser
  const globalObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
        updateKachingPrices();
        break;
      }
      if (m.type === "attributes") {
        updateKachingPrices();
        break;
      }
    }
  });

  globalObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false
  });

  // 4) Opdater ved variant-/valgskifte
  document.body.addEventListener("change", function (event) {
    if (event.target.matches("select, input[type='radio'], input[type='checkbox']")) {
      updateKachingPrices();
    }
  });

  // 5) Sikkerhed: kør også efter window.load
  window.addEventListener("load", () => updateKachingPrices());
});
